<template>
  <svg width="190" height="191" viewBox="0 0 190 191" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_1949_28016)">
      <circle cx="95" cy="85.5407" r="75" fill="white" />
    </g>
    <circle opacity="0.15" cx="95" cy="85.5406" r="75" :fill="themeColor.hex ?? color" />
    <path
      d="M69 56C65.5522 56 62.2456 57.3696 59.8076 59.8076C57.3696 62.2456 56 65.5522 56 69V69.7092C56 70.0771 56.202 70.4153 56.5259 70.5897L93.1038 90.2869C94.2876 90.9244 95.7125 90.9245 96.8963 90.2871L133.474 70.5962C133.798 70.4218 134 70.0836 134 69.7156V69C134 65.5522 132.63 62.2456 130.192 59.8076C127.754 57.3696 124.448 56 121 56H69ZM134 78.5276C134 78.1493 133.596 77.908 133.263 78.0873L96.5405 97.86C96.067 98.1149 95.5377 98.2483 95 98.2483C94.4623 98.2483 93.933 98.1149 93.4595 97.86L56.737 78.0873C56.4039 77.908 56 78.1493 56 78.5276V108C56 111.448 57.3696 114.754 59.8076 117.192C62.2456 119.63 65.5522 121 69 121H121C124.448 121 127.754 119.63 130.192 117.192C132.63 114.754 134 111.448 134 108V78.5276Z"
      :fill="themeColor.hex ?? color" />
    <g clip-path="url(#clip0_1949_28016)">
      <circle cx="150.467" cy="19" r="17" fill="white" />
      <path
        d="M179.063 31C179.063 47.0543 166.05 60.0625 150 60.0625C133.95 60.0625 120.938 47.0543 120.938 31C120.938 14.955 133.95 1.9375 150 1.9375C166.05 1.9375 179.063 14.955 179.063 31ZM150 36.8594C147.023 36.8594 144.609 39.2729 144.609 42.25C144.609 45.2271 147.023 47.6406 150 47.6406C152.977 47.6406 155.391 45.2271 155.391 42.25C155.391 39.2729 152.977 36.8594 150 36.8594ZM144.882 17.4829L145.751 33.4204C145.792 34.1662 146.409 34.75 147.156 34.75H152.844C153.591 34.75 154.208 34.1662 154.249 33.4204L155.118 17.4829C155.162 16.6773 154.521 16 153.714 16H146.286C145.479 16 144.838 16.6773 144.882 17.4829Z"
        :fill="themeColor.hex ?? color" />
    </g>
    <defs>
      <filter id="filter0_d_1949_28016" x="0" y="0.54068" width="190" height="190" filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha" />
        <feOffset dy="10" />
        <feGaussianBlur stdDeviation="10" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.333333 0 0 0 0 0.431373 0 0 0 0 0.901961 0 0 0 0.13 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1949_28016" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1949_28016" result="shape" />
      </filter>
      <clipPath id="clip0_1949_28016">
        <rect width="60" height="60" fill="white" transform="translate(120 1)" />
      </clipPath>
    </defs>
  </svg>
</template>
<script setup>
import {useTheme} from "@/stores/ThemeStore";

const {color: themeColor} = useTheme();

const props = defineProps({
    color: {
        type: String,
        required: false,
    },
});

</script>
